// @flow

import React from 'react';

import SimplePromo from 'app/login/components/SimplePromo';

import type { SimplePromoProps } from 'app/login/components/SimplePromo';

const LoginPromo = (props: SimplePromoProps) => {
  return (
    <SimplePromo
      {...props}
      condensedContent="Use Paths &mdash; Zapier‘s conditional logic tool &mdash; to build
        multiple outcomes into a single Zap."
      ctaHref="/paths"
      ctaText="Learn more"
      imgAlt="Build multiple outcomes into a single Zap with Paths!"
      imgSrc="/images/login/paths-login-promo.svg"
      tag="New"
      title="Build Smarter Workflows"
    >
      <p>
        Use Paths &mdash; Zapier‘s conditional logic tool &mdash; to build
        multiple outcomes into a single Zap.
      </p>
    </SimplePromo>
  );
};

export default LoginPromo;
